import React from "react";
import { Plus } from "lucide-react";
import { SECTION_DISPLAY_NAMES } from "./schemas";

const SECTION_NUM = {
  hero: null,
  what_this_is: "01",
  when_to_use: "02",
  where_it_fits: "03",
  private_by_design: "04",
  closing_tagline: null,
  footer: null,
  cta: null,
  step_labels: null,
};

// Visible placeholder for sections that have no content yet. Mirrors the
// shape of the real section card so the layout stays consistent and admins
// can click anywhere to start authoring.
const EmptySectionStub = ({ sectionKey, hint }) => {
  const label = SECTION_DISPLAY_NAMES[sectionKey] || sectionKey;
  const num = SECTION_NUM[sectionKey];

  if (sectionKey === "hero_image") {
    return (
      <div className="rounded-2xl border-2 border-dashed border-zinc-300 bg-white/40 h-32 flex items-center justify-center text-xs text-zinc-500">
        <span className="inline-flex items-center gap-1.5">
          <Plus className="h-3.5 w-3.5" />
          Click to add an optional hero image (banner)
        </span>
      </div>
    );
  }

  if (sectionKey === "hero") {
    return (
      <div className="rounded-xl border-2 border-dashed border-zinc-300 bg-white/40 px-6 py-10 flex flex-col items-start gap-3">
        <h1 className="corp-headline text-zinc-300 m-0">
          Add your headline…
        </h1>
        <p className="corp-headline-sub text-zinc-400 m-0">
          {hint || "Subtext that explains what Aris does for your team."}
        </p>
        <span className="inline-flex items-center gap-1.5 text-xs text-zinc-500 mt-2">
          <Plus className="h-3.5 w-3.5" />
          Click to add Hero
        </span>
      </div>
    );
  }

  if (sectionKey === "closing_tagline") {
    return (
      <div className="rounded-xl border-2 border-dashed border-zinc-300 bg-white/40 px-6 py-8 flex flex-col items-start gap-2">
        <p className="text-base text-zinc-400 m-0">
          A closing line that nudges the reader to activate…
        </p>
        <span className="inline-flex items-center gap-1.5 text-xs text-zinc-500">
          <Plus className="h-3.5 w-3.5" />
          Click to add Closing tagline
        </span>
      </div>
    );
  }

  if (sectionKey === "footer") {
    return (
      <div className="border-t border-dashed border-zinc-300 mt-6 pt-6 flex items-center justify-between text-xs text-zinc-400">
        <span>Sponsor line · Copyright</span>
        <span className="inline-flex items-center gap-1.5">
          <Plus className="h-3 w-3" />
          Click to add Footer
        </span>
      </div>
    );
  }

  return (
    <div className="rounded-xl border-2 border-dashed border-zinc-300 bg-white/40 px-6 py-7 flex flex-col gap-3">
      <div className="flex items-center gap-3">
        {num && (
          <span className="corp-section-num bg-zinc-100 text-zinc-400 border-zinc-200">
            {num}
          </span>
        )}
        <h2 className="corp-section-title text-zinc-400 m-0">{label}</h2>
      </div>
      <p className="text-sm text-zinc-400 m-0">
        {hint || "No content yet. Click to author this section."}
      </p>
      <span className="inline-flex items-center gap-1.5 text-xs text-zinc-500">
        <Plus className="h-3.5 w-3.5" />
        Click to add {label}
      </span>
    </div>
  );
};

export default EmptySectionStub;
